import React from "react";
import { loadData,addtoInventory } from "./itemSlice";
import { AddtoCart } from "./AddtoCart";
import displayitems from "./displayitems.module.css"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


export const DisplayItems = (props) => {
   // const listItems = props.items
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const listItems = useSelector(state => state.inventory)


    return (
        <div className={displayitems.itemsContainer} >
            {
             listItems.map(item => {
                return (
                <div key={item.id} className={displayitems.itemContainer} >
                    <img src={item.image} onClick={() => navigate(`/${item.name}`)}/>
                    <h3>{item.name}</h3>
                    <AddtoCart item={item} dispatch={dispatch} quantity={1}></AddtoCart>
                </div>
                )
             })
            }
        </div>
    )
}